import {
    USERJOBTRANSACTION_GET_MULTIPLE,
    USERJOBTRANSACTION_GET_ONE,
    USERJOBTRANSACTION_REGISTER_SUCCESS,
    USERJOBTRANSACTION_REGISTER_FAIL,
    USERJOBTRANSACTION_LOADING,
    USERJOBTRANSACTION_LOADING_ERROR,
    USERJOBTRANSACTION_ACTIVATE_FAIL,
    USERJOBTRANSACTION_ACTIVATE_SUCCESS,
    USERJOBTRANSACTION_UPDATE_SUCCESS,
    USERJOBTRANSACTION_UPDATE_FAIL,
    USERJOBTRANSACTION_DELETE_SUCCESS,
    USERJOBTRANSACTION_DELETE_FAIL,
    USERJOBTRANSACTION_EDIT
} from "../types/userjobtransaction";

let userjobtransactionStore = JSON.parse(localStorage.getItem('userjobtransaction'))

const initialState = {
    isLoading: false,
    userjobtransactions: userjobtransactionStore ? userjobtransactionStore : [],
    userjobtransaction:{},
    msg: null,
    isEdit:-1,
    ref:null,
}

const changeState = (aluu, actid) =>
{
    let newUserjobtransaction = [...aluu];
    newUserjobtransaction.forEach(alu => {
        if(alu.id == actid.id){
            alu.is_active = actid.is_active
        }
    });
    return newUserjobtransaction;
}


export default function(state = initialState, action){
    switch (action.type) {
        case USERJOBTRANSACTION_EDIT:
            return {
                ...state,
                isEdit : action.payload
        };
        case USERJOBTRANSACTION_LOADING:
            return {
                ...state,
                isLoading : true
            };
        case USERJOBTRANSACTION_GET_MULTIPLE:
            localStorage.setItem('userjobtransaction', JSON.stringify(action.payload));
            return {
                ...state,
                userjobtransactions : action.payload,
                msg:'DONE!!!'
            };
        case USERJOBTRANSACTION_GET_ONE:
            let all = [...state.userjobtransactions];
            let ses = all.filter(row=>row.id == action.payload)[0];
            return {
                ...state,
                userjobtransaction : ses,
                MSG:"DONE!!!"
            };
        case USERJOBTRANSACTION_REGISTER_SUCCESS:
            localStorage.setItem('userjobtransaction', JSON.stringify([...state.userjobtransactions, action.payload]));
            return {
                ...state,
                userjobtransactions: [...state.userjobtransactions, action.payload],
                msg:action.msg
            }; 
        case USERJOBTRANSACTION_ACTIVATE_SUCCESS:
            let ac = changeState(state.userjobtransactions, action.payload);
            localStorage.setItem('userjobtransaction', JSON.stringify(ac));
            return{
                ...state,
                msg:'DONE!!!',
                userjobtransactions: ac
            }
        case USERJOBTRANSACTION_DELETE_SUCCESS:
            let rem = state.userjobtransactions.filter(cat => cat.id != action.payload);
            localStorage.setItem('userjobtransaction', JSON.stringify(rem));
            return{
                ...state,
                msg:'DONE!!!',
                userjobtransactions: rem
            }
        case USERJOBTRANSACTION_UPDATE_SUCCESS:
            const findInd = state.userjobtransactions.findIndex(cat => cat.id == action.payload.id);
            let newState = [...state.userjobtransactions];
            newState[findInd] = action.payload;
            localStorage.setItem('userjobtransaction', JSON.stringify(newState));
            return {
                ...state,
                ...action.payload,
                userjobtransactions : newState,
                userjobtransaction:action.payload
            }; 
        case USERJOBTRANSACTION_LOADING_ERROR:
        case USERJOBTRANSACTION_ACTIVATE_FAIL:
        case USERJOBTRANSACTION_REGISTER_FAIL:
        case USERJOBTRANSACTION_DELETE_FAIL:
        case USERJOBTRANSACTION_UPDATE_FAIL:

            return {
                ...state,
                isLoading: false,
                msg: action.msg
            };
        default:
            return state;
    }

}